<ion-button
  mode="md"
  fill="clear"
  [id]="id"
  class="background-border main-button-here"
  [style.width]="width"
>
  <div class="item-content">
    <div class="item-content-name" #nameRef>
      <frontend-triple-dots width="{{ nameRef.offsetWidth }}px">
        <p>{{ selectedAccount }}</p>
      </frontend-triple-dots>
      <frontend-triple-dots width="{{ nameRef.offsetWidth }}px">
        <b>{{ selectedLocation?.locationName }}</b>
      </frontend-triple-dots>
    </div>
  </div>

  <tr-icon
    class="main-down-arrow"
    [icon]="icon.arrowDown"
    [color]="iconColor.primary"
    [size]="size.small"
  ></tr-icon>
</ion-button>

<ion-popover
  mode="ios"
  alignment="center"
  side="bottom"
  size="cover"
  [trigger]="id"
  [dismissOnSelect]="true"
>
  <ng-template>
    <ion-content [forceOverscroll]="false">
      <ion-list *ngIf="accounts.length === 1">
        <ng-container *ngFor="let location of accounts[0].locations">
          <ng-container *ngTemplateOutlet="locationItemTemplate; context: {
            locationId: location._id,
            locationName: location.name,
            account: selectedAccount,
            check: selectedLocation?.locationId === location._id
          }"></ng-container>
        </ng-container>
      </ion-list>

      <ion-list *ngIf="accounts.length > 1">
        <ng-container *ngFor="let account of accounts">
          <ng-container *ngTemplateOutlet="locationItemTemplate; context: {
            accountId: account.id,
            account: account.name,
            sameAccount: selectedAccount === account.name
          }"></ng-container>

          <ion-popover
            [trigger]="'nested-trigger-for-' + account.id"
            [dismissOnSelect]="true"
            [side]="popoverSide"
            alignment="start"
            triggerAction="hover"
            size="cover"
          >
            <ng-template>
              <ion-content [forceOverscroll]="false">
                <ion-list>
                  <ng-container *ngFor="let location of account.locations">
                    <ng-container *ngTemplateOutlet="locationItemTemplate; context: {
                      locationId: location._id,
                      locationName: location.name,
                      account: account.name,
                      check: selectedLocation?.locationId === location._id
                    }"></ng-container>
                  </ng-container>
                </ion-list>
              </ion-content>
            </ng-template>
          </ion-popover>
        </ng-container>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>

<ng-template
  #locationItemTemplate
  let-locationId="locationId"
  let-accountId="accountId"
  let-check="check"
  let-sameAccount="sameAccount"
  let-locationName="locationName"
  let-account="account"
>
  <ion-item
    [button]="true"
    [detail]="false"
    [id]="accountId ? 'nested-trigger-for-' + accountId : undefined"
    (click)="locationId ? selectLocation(locationId) : undefined"
    class="border-border"
  >
    <div class="item-content pl-3">
      <ng-container *ngIf="locationName">
        <div class="item-content-name" #nameRef>
          <frontend-triple-dots width="{{ nameRef.offsetWidth }}px">
            <p>{{ account }}</p>
          </frontend-triple-dots>

          <frontend-triple-dots width="{{ nameRef.offsetWidth }}px">
            <b>{{ locationName }}</b>
          </frontend-triple-dots>
        </div>
      </ng-container>

      <ng-container *ngIf="!locationName">
        <div class="item-content-name" #contentNameRef>
          <frontend-triple-dots width="{{ contentNameRef.offsetWidth }}px">
            <b>{{ account }}</b>
          </frontend-triple-dots>
        </div>
      </ng-container>

      <tr-icon
        *ngIf="!locationName"
        [color]="sameAccount ? iconColor.blue : iconColor.primary"
        [icon]="icon.arrowRight"
        [size]="size.small"
      ></tr-icon>

      <tr-icon
        *ngIf="check"
        [icon]="icon.check"
        [color]="iconColor.blue"
        [size]="size.regular"
      ></tr-icon>
    </div>
  </ion-item>
</ng-template>
